import { render } from "./Coffers.vue?vue&type=template&id=fdfae508&scoped=true"
import script from "./Coffers.vue?vue&type=script&lang=js"
export * from "./Coffers.vue?vue&type=script&lang=js"

import "./Coffers.vue?vue&type=style&index=0&id=fdfae508&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fdfae508"

export default script